<script setup lang="ts">
const MGMT_URL = 'https://support.bazeport.net';
</script>

<template>
    <div class="max-w-2xl mx-auto px-4 sm:px-6 py-6">
        <h1 class="text-2xl font-semibold mb-3">Connect</h1>
        <p class="text-slate-400 text-sm mb-6">
            Install the NetBird client and point it at the Bazeport support
            management server. You will be prompted to sign in with your
            passkey on first launch — no setup-key is needed.
        </p>

        <div class="bg-bp-panel border border-bp-border rounded p-3 sm:p-4">
            <h2 class="font-semibold mb-2 text-sm">Install</h2>
            <!--
                overflow-x-auto + whitespace-pre preserves the command formatting
                instead of letting it wrap at unfortunate places, while still
                allowing horizontal swipe on phones.
            -->
            <pre class="bg-bp-bg border border-bp-border px-3 py-2 rounded text-xs whitespace-pre overflow-x-auto"># macOS / Linux
brew install netbirdio/tap/netbird   # or follow the official installer
netbird up --management-url {{ MGMT_URL }}

# Windows (latest NetBird client)
# 1. Download and run the latest installer from
#    https://github.com/netbirdio/netbird/releases/latest
# 2. Right-click the NetBird icon in the system tray and choose
#    Settings → "Advanced Settings".
# 3. On the "Connection" tab, set "Management URL" to
#    {{ MGMT_URL }}, then save.
# 4. Right-click the tray icon again and choose "Connect".
#    A browser window opens for passkey login.</pre>

            <p class="text-slate-400 text-xs mt-3">
                Don't have a passkey yet? Check your inbox for the activation
                email from the Bazeport VPN team.
            </p>
        </div>
    </div>
</template>
